import snakeCase from 'lodash/snakeCase'

export const DataTypes = {
    accommodations: [
        'accommodations_in_italy',
        'total_accommodations',
        'online_accommodations',
        'online_apartments',
        // 'percent_airbnb_accommodations',
        'economics_per_inhabitant'
    ],
    guestsSatisfactions: [
        'accommodations_reviews',
        'apartments_reviews',
        'percent_accommodation_satisfaction',
        'percent_apartment_satisfaction',
        'percent_airbnb_5_stars_review'
    ],
    touristSource: [
        'total_arrivals',
        'percent_variance_arrivals',
        'total_reviews',
        'total_attendances_airbnb',
        'percent_variance_arrivals_airbnb'
    ]
}

export const getAccommodationsDataTypeMenuItems = (tFunc) => {
    const dataTypeMenuItems = DataTypes.accommodations.map((dataType, index) => {
        return {value: dataType, label: tFunc(`data_types.${dataType}`)}
    })

    dataTypeMenuItems.unshift({value: 'all', label: tFunc('data_types.all')})

    return dataTypeMenuItems
}

export const getGuestsSatisfactionDataTypeMenuItems = (tFunc) => {
    const dataTypeMenuItems = DataTypes.guestsSatisfactions.map((dataType, index) => {
        return {value: dataType, label: tFunc(`data_types.${dataType}`)}
    })

    dataTypeMenuItems.unshift({value: 'all', label: tFunc('data_types.all')})

    return dataTypeMenuItems
}

export const getTouristSourceDataTypeMenuItems = (tFunc) => {
    const dataTypeMenuItems = DataTypes.touristSource.map((dataType, index) => {
        return {value: dataType, label: tFunc(`data_types.${dataType}`)}
    })

    dataTypeMenuItems.unshift({value: 'all', label: tFunc('data_types.all')})

    return dataTypeMenuItems
}


// WEBPACK FOOTER //
// ./src/libs/DataTypes.js